var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-btn",class:_vm.model.isCollect ? 'btn-red' : 'btn-default',on:{"click":function($event){return _vm.$com.addCollect(_vm.model, _vm.type)}}},[_vm._v("\n  "+_vm._s(_vm.model.isCollect ? '移除书架' : '加入书架')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a21f8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/ButtonCollectView.vue
// module id = null
// module chunks = 